import { Injectable } from '@angular/core';
import { OrganizationService } from "./generatedServices";
import { ConferenceRegistrantViewModel, ConferenceViewModel, OrganizationViewModel, RegistrantSearchParameters } from "../_models/generatedModels";
import { ActivatedRoute, Router } from "@angular/router";

@Injectable()
export class CheckinService {
  public user: ConferenceRegistrantViewModel;
  public conference: ConferenceViewModel;
  public organization: OrganizationViewModel;
  public mode: 'checkin' | 'rekey';
  public rfidEnabled: boolean;

  constructor(private orgService: OrganizationService, private route: ActivatedRoute, private router: Router) {

    // if (this.user == null) {
    //   var url = this.router.url.replace('/preview','');
    //   console.log(url);
    //   this.router.navigateByUrl(url);
    // }
  }

  reloadUser(){
    var model = new RegistrantSearchParameters();
    model.currentPage = 0;
    model.pageSize = 20;
    model.specificUsers = [this.user.id];
    model.searchText = '';
    this.orgService.getRegistrantsForConference(this.organization.id.toString(), this.conference.id, model).subscribe(
      (result) => {
        this.user = result.users[0];
      },
      (error) => {
        console.log(error);
      }
    );
  }


  reset() {
    this.user = null;
    this.conference = null;
    this.organization = null;
  }


}
